"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isYearProperty = exports.yearPropertyDefinition = void 0;
exports.yearPropertyDefinition = {
    view: { label: 'Year' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'max',
            argument: 2100,
        },
        {
            name: 'min',
            argument: 1700,
        },
    ],
    type: 'int',
    multiple: false,
    name: 'year',
};
const isYearProperty = (prop) => {
    return prop.name === exports.yearPropertyDefinition.name;
};
exports.isYearProperty = isYearProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoieWVhci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3llYXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFO0lBQ3ZCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLEtBQUs7WUFDWCxRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsS0FBSztZQUNYLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7S0FDRjtJQUNELElBQUksRUFBRSxLQUFLO0lBQ1gsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsTUFBTTtDQUNtQixDQUFBO0FBSTFCLE1BQU0sY0FBYyxHQUFHLENBQUMsSUFBa0IsRUFBd0IsRUFBRTtJQUN6RSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssOEJBQXNCLENBQUMsSUFBSSxDQUFBO0FBQ2xELENBQUMsQ0FBQTtBQUZZLFFBQUEsY0FBYyxrQkFFMUIifQ==